import AtNotification from 'utils/at-notification';

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.getElementsByClassName('at-copy')).forEach((el) => {
    el.addEventListener('click', () => {
      navigator.clipboard.writeText(el.dataset.url).then(
        () => {
          const notification = new AtNotification('Copied to clipboard', 'notice', 2500);
          document.body.appendChild(notification.el);
        },
        () => {
          const notification = new AtNotification('Copy to clipboard failed', 'alert', 2500);
          document.body.appendChild(notification.el);
        }
      );
    });
  });
});
